export default {
	// url: "https://localhost:44305/api/v0/",
	// tokenService: "https://localhost:44305/token",

	url: process.env.VUE_APP_ROOT_API,
	tokenService: process.env.VUE_APP_ROOT_API,
	chatSignalRUrl: process.env.VUE_APP_CHAT_SIGNALR_URL
}
